import { TesseraClient } from '@lopettia/tessera-client';

/**
 * Shared TesseraClient instance for the kairos-web SPA.
 *
 * Tessera issuer + client_id come from Vite env (build-time
 * substitution). The `redirectUri` / `postLogoutRedirectUri` are
 * computed at module-load against `window.location.origin` so the
 * same build works in any environment (localhost dev, staging, prod).
 *
 * `storageKey: 'kairos.auth'` makes the SDK write into the same
 * localStorage slot Zustand's `persist({ name: 'kairos.auth' })`
 * already owns. Existing `useAuthStore((s) => s.tokens)` call sites
 * continue to read from there without any change.
 */
const ISSUER =
  (import.meta.env.VITE_TESSERA_ISSUER as string | undefined) ?? 'http://localhost:8090';
export const TESSERA_CLIENT_ID =
  (import.meta.env.VITE_TESSERA_CLIENT_ID as string | undefined) ?? 'tessera-client-kairos';

export const sdk = new TesseraClient({
  issuer: ISSUER,
  clientId: TESSERA_CLIENT_ID,
  redirectUri: `${window.location.origin}/auth/callback`,
  postLogoutRedirectUri: `${window.location.origin}/login`,
  storageKey: 'kairos.auth',
});

/**
 * Create a one-shot TesseraClient for a specific issuer (e.g. the prod
 * Tessera staff issuer returned by /auth/method for @lopettia.ai users).
 * Uses the same callback URI and client_id as the default sdk instance.
 */
export function makeSdkForIssuer(issuerUri: string): TesseraClient {
  return new TesseraClient({
    issuer: issuerUri,
    clientId: TESSERA_CLIENT_ID,
    redirectUri: `${window.location.origin}/auth/callback`,
    postLogoutRedirectUri: `${window.location.origin}/login`,
    storageKey: 'kairos.auth',
  });
}
